import React from 'react';
import PropTypes from 'prop-types';
import { CardItem } from '../../../Card/CardItem';
import { contentPackageSmallStyle } from '../style/contentPackageSmallStyle';
import { getContentPackageStackCardDatum } from './utils/contentPackageUtils';
import { GridColumn, GridRow } from '../../../responsive/atoms/Grid';
import { ContentPackageHeaderSection } from '../ContentPackageHeaderSection';
import { Container } from '../../../responsive/atoms/Container';

const imageMaxWidths = {
  mobile: 727,
  tablet: 309,
  small_desktop: 384,
  large_desktop: 480
};

export const ContentPackageTemplate3c = ({ data, isAboveTheFold = false }) => {
  const stackCardDatum = getContentPackageStackCardDatum(data);
  const stylesSmall = contentPackageSmallStyle(data.backgroundColor);
  const hasHeaderSection = !!(data.contentPackageHeader || data.description);

  return (
    <Container margin="0 auto" backgroundColor={data.backgroundColor}>
      <Container
        maxWidth="100rem"
        padding={
          hasHeaderSection
            ? [
                '0 20px 56px 20px',
                '0 24px 80px 24px',
                '0 40px 80px 40px',
                '0 56px 80px 56px'
              ]
            : ['20px', '24px', '40px', '56px']
        }
        backgroundColor={data.backgroundColor}
      >
        {hasHeaderSection && (
          <ContentPackageHeaderSection
            title={data.contentPackageHeader}
            description={data.description}
          />
        )}

        <GridRow gutter={['20px', '12px']}>
          <GridColumn width={[12, 4]}>
            {stackCardDatum[0] && (
              <CardItem
                styles={stylesSmall}
                data={stackCardDatum[0]}
                aspect="16x9"
                isAboveTheFold={isAboveTheFold}
                imageMaxWidths={imageMaxWidths}
              />
            )}
          </GridColumn>

          <GridColumn width={[12, 4]}>
            {stackCardDatum[1] && (
              <CardItem
                styles={stylesSmall}
                data={stackCardDatum[1]}
                aspect="16x9"
                isAboveTheFold={isAboveTheFold}
                imageMaxWidths={imageMaxWidths}
                canBeAnimated
              />
            )}
          </GridColumn>

          <GridColumn width={[12, 4]}>
            {stackCardDatum[2] && (
              <CardItem
                styles={stylesSmall}
                data={stackCardDatum[2]}
                aspect="16x9"
                isAboveTheFold={isAboveTheFold}
                imageMaxWidths={imageMaxWidths}
              />
            )}
          </GridColumn>
        </GridRow>
      </Container>
    </Container>
  );
};

ContentPackageTemplate3c.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  // content not used in this template, because it doesn't use any Ad.
  // content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
